export default {
    primary : "#e66767",
    grayBackground:'#FAFAFA',
    gold:'#D9C580',
    componentStyle:{
        marginTop:60,
        padding:20
    }
}
